import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { ButtonUtilityDirective } from '../directives/index';
import { MenuButtonComponent } from '../menu-button/menu-button.component';
import { NavbarConfig } from './navbar.interface';

@Component({
  selector: 'nbx-navbar',
  standalone: true,
  imports: [
    FormsModule,
    BreadcrumbComponent,
    ButtonModule,
    TooltipModule,
    MenuButtonComponent,
    ButtonUtilityDirective,
    TranslocoModule,
  ],
  templateUrl: './navbar.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  public readonly config = input<NavbarConfig>({});
  public readonly styleClass = input<string>('');
  public readonly menuClick = output<void>();
  public readonly logoClick = output<void>();

  readonly navClass = computed(() => {
    const extra = this.styleClass();
    return `bg-white flex items-center justify-between w-full ${extra ? ` ${extra}` : ''}`;
  });

  public onLogoClick(): void {
    this.logoClick.emit();
  }
}
